"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var es6_promise_1 = require("es6-promise");
var gcs = require("./GoCloudStorage");
var GoNetCore = (function (_super) {
    __extends(GoNetCore, _super);
    function GoNetCore(managedDiagrams, rootEndpoint, defaultModel, iconsRelativeDirectory) {
        var _this = _super.call(this, managedDiagrams, defaultModel) || this;
        _this._rootEndpoint = rootEndpoint;
        _this.ui.id = 'goNetCoreCustomFilepicker';
        _this._serviceName = 'Microsoft ASP .NET Core Web API';
        _this._className = 'GoNetCore';
        return _this;
    }
    Object.defineProperty(GoNetCore.prototype, "rootEndpoint", {
        get: function () { return this._rootEndpoint; },
        enumerable: true,
        configurable: true
    });
    GoNetCore.prototype.authorize = function (refreshToken) {
        if (refreshToken === void 0) { refreshToken = false; }
        var storage = this;
        return new es6_promise_1.Promise(function (resolve, reject) {
            resolve(true);
        });
    };
    GoNetCore.prototype.showUI = function (action, numAdditionalFiles) {
        var storage = this;
        var ui = storage.ui;
        var spacestring = 'qwe45qw34';
        if (!numAdditionalFiles)
            numAdditionalFiles = 0;
        var maxFilesToShow = GoNetCore._MIN_FILES_IN_UI + numAdditionalFiles;
        ui.innerHTML = '';
        var title = action + ' Diagram File';
        ui.innerHTML += '<strong>' + title + '</strong><hr></hr>';
        document.getElementsByTagName('body')[0].appendChild(ui);
        ui.style.visibility = 'visible';
        var filesDiv = document.createElement('div');
        filesDiv.id = 'fileOptions';
        var savedDiagrams = [];
        var numFilesToCheck = GoNetCore._MIN_FILES_IN_UI + numAdditionalFiles;
        var numFilesChecked = 0;
        var hasCheckedAllFiles = false;
        storage.getFiles().then(function (files) {
            if (files.length !== 0) {
                for (var i in files) {
                    var item = files[i];
                    if (savedDiagrams.length < maxFilesToShow) {
                        numFilesChecked++;
                        var fileContent = item.file;
                        if (fileContent && fileContent.indexOf('GraphLinksModel' || 'TreeModel') !== -1) {
                            var file = { name: item.name, id: item.id };
                            savedDiagrams.push(file);
                        }
                        if (numFilesChecked === files.length)
                            hasCheckedAllFiles = true;
                    }
                }
            }
            else
                hasCheckedAllFiles = true;
            if (savedDiagrams.length !== 0) {
                for (var i = 0; i < savedDiagrams.length; i++) {
                    var item = savedDiagrams[i];
                    var name_1 = item.name;
                    var id = item.id;
                    if (action !== 'Save') {
                        filesDiv.innerHTML +=
                            "<div class='fileOption'>" +
                                '<input id=' + id + " type='radio' name='localStorageFile' />" +
                                '<label id =' + id + '-label' + " for='" + name_1 + "'>" + name_1 + '</label>' +
                                '</div>';
                    }
                    else {
                        filesDiv.innerHTML +=
                            "<div class='fileOption'>" +
                                '<label id =' + id + '-label' + " for='" + id + "'>" + name_1 + '</label>' +
                                '</div>';
                    }
                }
            }
            if (!hasCheckedAllFiles) {
                var num_1 = numAdditionalFiles + 50;
                filesDiv.innerHTML += "<p>There may be more diagram files not shown. <a id='netCoreLoadMoreFiles'>Click here</a> to try loading more.</p>";
                document.getElementById('netCoreLoadMoreFiles').onclick = function () {
                    storage.showUI(action, num_1);
                };
            }
            ui.appendChild(filesDiv);
            if (storage.currentDiagramFile.id) {
                var el = document.getElementById(storage.currentDiagramFile.id + '-label');
                if (el)
                    el.style.fontStyle = 'italic';
            }
            if (action === 'Save') {
                var userInputDiv = document.createElement('div');
                userInputDiv.id = 'userInputDiv';
                userInputDiv.innerHTML += '<span>Save Diagram As </span><input id="userInput" placeholder="Enter filename"></input>';
                ui.appendChild(userInputDiv);
            }
            var submitDiv = document.createElement('div');
            submitDiv.id = 'submitDiv';
            var actionButton = document.createElement('button');
            actionButton.textContent = action;
            actionButton.id = 'actionButton';
            actionButton.onclick = function () {
                storage.processUIResult(action);
            };
            submitDiv.appendChild(actionButton);
            ui.appendChild(submitDiv);
            var cancelDiv = document.createElement('div');
            var cancelButton = document.createElement('button');
            cancelButton.id = 'cancelButton';
            cancelButton.textContent = 'Cancel';
            cancelButton.onclick = function () {
                storage.hideUI(true);
            };
            cancelDiv.appendChild(cancelButton);
            ui.appendChild(cancelDiv);
        });
        return storage._deferredPromise['promise'];
    };
    GoNetCore.prototype.processUIResult = function (action) {
        var storage = this;
        function getSelectedFile() {
            var radios = document.getElementsByName('localStorageFile');
            var selectedFile = null;
            for (var i = 0; i < radios.length; i++) {
                if (radios[i].checked) {
                    selectedFile = radios[i].id.replace(/qwe45qw34/g, ' ');
                }
            }
            if (selectedFile)
                return selectedFile;
            else
                return null;
        }
        var file = getSelectedFile();
        switch (action) {
            case 'Save': {
                var name_2 = document.getElementById('userInput').value;
                if (name_2) {
                    name_2 += '.diagram';
                    storage.save(name_2);
                }
                else {
                }
                break;
            }
            case 'Load': {
                storage.load(file);
                break;
            }
            case 'Delete': {
                storage.remove(file);
                break;
            }
        }
        storage.hideUI();
    };
    GoNetCore.prototype.getFile = function (path) {
        var storage = this;
        var url = storage.rootEndpoint + path;
        return new es6_promise_1.Promise(function (resolve, reject) {
            if (path) {
                var xhr_1 = new XMLHttpRequest();
                xhr_1.open('GET', url, true);
                xhr_1.onreadystatechange = function () {
                    if (xhr_1.readyState === 4) {
                        if (xhr_1.status >= 200 && xhr_1.status < 300) {
                            resolve((JSON.parse(xhr_1.response)));
                        }
                    }
                };
                xhr_1.send();
            }
            else
                reject('Cannot get diagram file from ASP .NET Core Web API with id ' + path);
        });
    };
    GoNetCore.prototype.getFiles = function () {
        var storage = this;
        return new es6_promise_1.Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', storage.rootEndpoint, true);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        resolve(JSON.parse(xhr.response));
                    }
                    else
                        reject(xhr.response);
                }
            };
            xhr.send();
        });
    };
    GoNetCore.prototype.checkFileExists = function (path) {
        var storage = this;
        var url = storage.rootEndpoint + path;
        return new es6_promise_1.Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        resolve((true));
                    }
                    else {
                        resolve(false);
                    }
                }
            };
            xhr.send();
        });
    };
    GoNetCore.prototype.saveWithUI = function () {
        var storage = this;
        return new es6_promise_1.Promise(function (resolve, reject) {
            resolve(storage.showUI('Save'));
        });
    };
    GoNetCore.prototype.save = function (path) {
        var storage = this;
        return new es6_promise_1.Promise(function (resolve, reject) {
            if (storage.currentDiagramFile.id && !path) {
                var xhr_2 = new XMLHttpRequest();
                storage.getFile(storage.currentDiagramFile.id).then(function (resp) {
                    var item = {
                        id: storage.currentDiagramFile.id,
                        name: storage.currentDiagramFile.name,
                        file: storage.makeSaveFile()
                    };
                    var savedFile = { id: item.id, name: item.name, path: item.name };
                    xhr_2.open('PUT', storage.rootEndpoint + storage.currentDiagramFile.id, true);
                    xhr_2.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
                    xhr_2.onreadystatechange = function () {
                        if (xhr_2.readyState === 4) {
                            if (xhr_2.status > 200 && xhr_2.status < 300) {
                                resolve(savedFile);
                            }
                            else {
                                reject(xhr_2.responseText);
                            }
                        }
                    };
                    xhr_2.send(JSON.stringify(item));
                });
            }
            else {
                var xhr_3 = new XMLHttpRequest();
                var item_1 = {
                    name: (path !== null) ? path : 'New diagram',
                    file: storage.makeSaveFile()
                };
                xhr_3.open('POST', storage.rootEndpoint, true);
                xhr_3.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
                xhr_3.onreadystatechange = function () {
                    if (xhr_3.readyState === 4) {
                        if (xhr_3.status > 200 && xhr_3.status < 300) {
                            var id = JSON.parse(xhr_3.response).id;
                            var savedFile = { id: id, name: item_1.name, path: item_1.name };
                            storage.currentDiagramFile = savedFile;
                            resolve(savedFile);
                            storage._deferredPromise['promise'].resolve(savedFile);
                            storage._deferredPromise['promise'] = storage.makeDeferredPromise();
                        }
                        else {
                            reject(xhr_3.responseText);
                        }
                    }
                };
                xhr_3.send(JSON.stringify(item_1));
            }
        });
    };
    GoNetCore.prototype.loadWithUI = function () {
        var storage = this;
        return new es6_promise_1.Promise(function (resolve, reject) {
            resolve(storage.showUI('Load'));
        }).catch(function (e) {
            throw Error(e);
        });
    };
    GoNetCore.prototype.load = function (path) {
        var storage = this;
        return new es6_promise_1.Promise(function (resolve, reject) {
            if (path) {
                var xhr_4 = new XMLHttpRequest();
                xhr_4.open('GET', storage.rootEndpoint + path, true);
                xhr_4.onreadystatechange = function () {
                    if (xhr_4.readyState === 4) {
                        if (xhr_4.status >= 200 && xhr_4.status < 300) {
                            var respJSON = JSON.parse(xhr_4.response);
                            storage.loadFromFileContents(respJSON.file);
                            var loadedFile = { id: respJSON.id, path: respJSON.name, name: respJSON.name };
                            storage.currentDiagramFile = loadedFile;
                            resolve(loadedFile);
                            storage._deferredPromise.promise.resolve(loadedFile);
                            storage._deferredPromise.promise = storage.makeDeferredPromise();
                        }
                        else {
                            reject(xhr_4.responseText);
                        }
                    }
                };
                xhr_4.send();
            }
            else
                throw Error('Cannot load file from .NET Core Web API with path ' + path);
        }).catch(function (e) {
            throw Error(e);
        });
    };
    GoNetCore.prototype.removeWithUI = function () {
        var storage = this;
        return new es6_promise_1.Promise(function (resolve, reject) {
            resolve(storage.showUI('Delete'));
        });
    };
    GoNetCore.prototype.remove = function (path) {
        var storage = this;
        return new es6_promise_1.Promise(function (resolve, reject) {
            if (path) {
                storage.getFile(path).then(function (resp) {
                    var deletedFile = { name: resp.name, path: resp.name, id: path };
                    if (storage.currentDiagramFile && resp.name === storage.currentDiagramFile.name)
                        storage.currentDiagramFile = { name: null, path: null, id: null };
                    var xhr = new XMLHttpRequest();
                    xhr.open('DELETE', storage.rootEndpoint + path, true);
                    xhr.onreadystatechange = function () {
                        if (xhr.readyState === 4) {
                            if (xhr.status >= 200 && xhr.status < 300) {
                                resolve(deletedFile);
                                storage._deferredPromise['promise'].resolve(deletedFile);
                                storage._deferredPromise['promise'] = storage.makeDeferredPromise();
                            }
                            else {
                                reject(xhr.responseText);
                            }
                        }
                    };
                    xhr.send();
                });
            }
            else
                throw Error('Cannot delete file from local storage with id ' + path);
        });
    };
    GoNetCore._MIN_FILES_IN_UI = 100;
    return GoNetCore;
}(gcs.GoCloudStorage));
exports.GoNetCore = GoNetCore;
